import { COMPONENTS } from '../../lib/constants';

export const LogoView = {
	name: COMPONENTS.LOGO,
	position: {
		x: 0,
		y: 0
	},
	components: [
		{
			name: 'logo',
			type: 'Sprite',
			components: [
				{
					name: 'logo',
					type: 'Sprite',
					img: 'kyoto_logo',
					position: {
						x: -40,
						y: -15
					}
				}
			]
		}
	]
};
